/* eslint-disable */
//messages.js
module.exports = {
  general: 'General',
  overview: 'Overview',
  customizer: 'Customizer',
  applications: 'Application',
  features: 'Features',
  components: 'Components',
  applications: 'Applications',
  features: 'Features',
  salesAndVisitStats: 'SALES & VISITS STATS',
  orderAndProjectStats: 'Order & Projects Stats',
  fitnessStats: 'Fitness Stats',
  supportAndUsefulWidgets: 'Support & Usefull Widgets',
  dashboard: 'Dashboard',
  lookup_records: '记录查询',
  Sale: '销售',
  sale_orders: '销售详单',
  shop_stock:'店内库存',
  shop_cash_mng:"现金管理",
  shop_new_vip:"新增会员",
  shop_user_saved:"用户暂存",
  shop_user_prepay:"用户充值",
  shop_ship_order:"店铺调拨",
  shop_recv_order:"店铺收货",
  shop_pandian_order:"店铺盘点",
  shop_destroy_order:"商品报损",
  shop_request_order:"配货申请",


  dashboardv1: 'Dashboard V1',
  dashboardv2: 'Dashboard V2',
  pages: 'Pages',
  gallery: 'Gallery',
  pricing: 'Pricing',
  blank: 'Blank',
  session: 'Session',
  signUp: 'Sign Up',
  login: 'Login',
  lockScreen: 'Lock Screen',
  uiElements: 'UI Elements',
  buttons: 'Buttons',
  cards: 'Cards',
  checkbox: 'Checkbox',
  carousel: 'Carousel',
  chips: 'Chips',
  datepicker: 'Datepicker',
  dialog: 'Dialog',
  grid: 'Grid',
  input: 'Input',
  list: 'List',
  menu: 'Menu',
  progress: 'Progress',
  radio: 'Radio',
  select: 'Select',
  slider: 'Slider',
  snackbar: 'Snackbar',
  tabs: 'Tabs',
  toolbar: 'Toolbar',
  tooltip: 'Tooltip',
  timepicker: 'Timepicker',
  forms: 'Forms',
  formValidation: 'Form Validation',
  stepper: 'Stepper',
  charts: 'Charts',
  vueChartjs: 'Vue Chartjs',
  vueEcharts: 'Vue Echarts',
  icons: 'Icons',
  themify: 'Themify',
  material: 'Material',
  tables: 'Tables',
  standard: 'Standard',
  slots: 'Slots',
  selectable: 'Selectable',
  searchRow: 'Search Row',
  maps: 'Maps',
  googleMaps: 'Google Maps',
  leafletMaps: 'Leaflet Maps',
  jvectorMap: 'Jvector Map',
  inbox: 'Inbox',
  users: 'Users',
  userProfile: 'User Profile',
  usersList: 'Users List',
  calendar: 'Calendar',
  editor: 'Editor',
  quillEditor: 'Quill Editor',
  wYSIWYG: 'WYSIWYG',
  vue2Dragula: 'Vue2 Dragula',
  dragAndDrop: 'Drag And Drop',
  vueDraggable: 'Vue Draggable',
  draggableResizeable: 'Draggable Resizeable'
}



// WEBPACK FOOTER //
// ./src/lang/en/strings.js